import {fireStorage} from './fire'
import {ref, uploadBytes} from 'firebase/storage'

export default async function saveMp3(blobURL, userID, dateString,
                                      label = 'default') {
    const newMp3Path = userID + '_' + dateString + '_' + label + '.mp3'
    let blob = await fetch(blobURL).then(r =>  r.blob())
    const storeMp3Ref = ref(fireStorage, newMp3Path)
    return uploadBytes(storeMp3Ref, blob)
}